import { ReactNode } from 'react';

import { Box } from '@aicon-dev/caas-core';

import IconButton from '~/modules/comments/components/CommentInput/IconButton';

interface IModalProps {
  zIndex: number;
  header?: boolean;
  headerTitle?: string;
  icon?: ReactNode;
  children: ReactNode;
  onClick: () => void;
}

export const Modal = ({ zIndex, header, headerTitle, icon, children, onClick }: IModalProps) => {
  return (
    <Box
      width="100%"
      height="100dvh"
      zIndex={zIndex}
      backgroundColor="#00000073"
      style={{ position: 'fixed', top: 0, left: 0 }}
    >
      {header && headerTitle && <IconWithTitle title={headerTitle} icon={icon} onClick={onClick} />}
      {children}
    </Box>
  );
};

interface Props {
  title: string;
  icon: ReactNode;
  onClick: () => void;
}

const IconWithTitle = ({ title, icon, onClick }: Props) => {
  return (
    <Box display="flex" alignItems="center">
      <IconButton icon={icon} onClick={onClick} />
      <Box marginLeft="8px" fontSize="18px" fontWeight="normal">
        {title}
      </Box>
    </Box>
  );
};
